import React from "react";

const Analytics = () => <div>Analytics</div>;

export default Analytics;
